import { faChevronLeft } from '@fortawesome/pro-regular-svg-icons';
import { FormattedMessage, defineMessages } from 'react-intl';
import { useNavigate } from 'react-router';
import styled from 'styled-components';

import { Button } from '@sorare/core/src/atoms/buttons/Button';
import { FontAwesomeIcon } from '@sorare/core/src/atoms/icons';
import { useIsMobileApp } from '@sorare/core/src/hooks/useIsMobileApp';

import { useClearAllFilters } from '#src/search/ClearAllFilters/index.tsx';

const messages = defineMessages({
  clearFilters: {
    id: 'NoResults.clearFilters',
    defaultMessage: 'Clear all filters',
  },
  goBack: {
    id: 'NoResults.goBack',
    defaultMessage: 'Go back',
  },
});

const CTAs = styled.div`
  display: flex;
  gap: var(--unit);
`;

export const NoResults = () => {
  const { isIosApp, isMarketAuthorizedIosApp } = useIsMobileApp();
  const clearAllFilters = useClearAllFilters();
  const navigate = useNavigate();

  return (
    <CTAs>
      {!!(!isIosApp || isMarketAuthorizedIosApp) && (
        <Button
          size="medium"
          color="quaternary"
          onClick={() => navigate(-1)}
          startIcon={<FontAwesomeIcon icon={faChevronLeft} />}
        >
          <FormattedMessage {...messages.goBack} />
        </Button>
      )}
      <Button size="medium" color="primary" onClick={clearAllFilters}>
        <FormattedMessage {...messages.clearFilters} />
      </Button>
    </CTAs>
  );
};
